<template>
    <v-row
        v-if="privileges != false && Object.keys(privileges).length != 0"
        dense
    >
        <v-checkbox v-model="debug" label="Show all"></v-checkbox>
        <template v-for="section in sections">
            <v-col
                v-if="isVisible(section) || debug"
                :key="section.title"
                cols="12"
                md="12"
            >
                <v-row>
                    <v-col cols="12">
                        <v-row dense align="center">
                            <v-col cols="auto">
                                <h2>{{ section.title }}</h2>
                            </v-col>
                            <v-col>
                                <v-divider></v-divider>
                            </v-col>
                        </v-row>
                    </v-col>
                    <template v-for="item in section.items">
                        <v-col
                            v-if="privileges[item.priv] || debug"
                            :key="item.title"
                            cols="auto"
                        >
                            <router-link
                                style="text-decoration: none;"
                                :to="item.route || ''"
                            >
                                <v-row no-gutters class="fill-height">
                                    <v-col
                                        class="text-center px-2"
                                        style="width: 125px"
                                    >
                                        <v-icon
                                            :class="
                                                item.route
                                                    ? 'primary--text'
                                                    : 'grey--text'
                                            "
                                            size="45"
                                        >
                                            {{ item.icon }}
                                        </v-icon>
                                        <h3
                                            class="text-center primary--text fill-height pt-2"
                                            align="end"
                                        >
                                            {{ item.title }}
                                        </h3>
                                    </v-col>
                                </v-row>
                            </router-link>
                        </v-col>
                    </template>
                </v-row>
            </v-col>
        </template>
    </v-row>
    <v-row v-else>
        <v-col>
            <v-progress-linear
                indeterminate
                height="8"
                rounded
                color="primary"
            ></v-progress-linear>
        </v-col>
    </v-row>
</template>

<script>
export default {
	props: {
		privileges: {
			type: Object,
			default: () => {},
		},
		sections: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			debug: false,
		};
	},
	methods: {
		isVisible(section) {
			const sectionPrivs = section.items.map((item) => item.priv);
			for (const priv of sectionPrivs) {
				if (this.privileges[priv]) {
					return true;
				}
			}
		},
	},
};
</script>
